// extracted by mini-css-extract-plugin
module.exports = {"color":"color___2nU7I"};